import React from 'react';
const blocks = [{
  letter: 'R',
  title: 'REALITATE',
  subtitle: 'Înțelege ce simți, fără judecată.',
  description: 'Te simți blocat(ă) și nu știi de ce? Ai emoții amestecate, te critici, îți e frică să greșești și ajungi să amâni. Aici înveți să înțelegi ce simți, fără rușine și fără să te forțezi „să fii bine".',
  icon: <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-12 h-12 text-rise-gold" data-id="element-77" data-mp="2u5llh54mrvkq">
        {/* Eye / awareness symbol */}
        <path d="M4 24C4 24 12 10 24 10C36 10 44 24 44 24C44 24 36 38 24 38C12 38 4 24 4 24Z" data-id="element-78" data-mp="21go3l34c00si" />
        <circle cx="24" cy="24" r="7" data-id="element-79" data-mp="26g0qfnv7d7v3" />
        <circle cx="24" cy="24" r="3" fill="currentColor" data-id="element-80" data-mp="2b9bw3loa3ilf" />
      </svg>
}, {
  letter: 'I',
  title: 'IDENTITATE',
  subtitle: 'Descoperă cine ești cu adevărat.',
  description: 'Nu știi ce vrei sau ce ți se potrivește? Te compari, te îndoiești, te simți „în urmă". Aici îți clarifici valorile, talentele și direcția care chiar ți se potrivește, nu ce „trebuie".',
  icon: <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-12 h-12 text-rise-gold" data-id="element-81" data-mp="ol16vjvv6lft">
        {/* Fingerprint / identity symbol */}
        <path d="M24 6C14 6 8 14 8 24" strokeDasharray="2 3" data-id="element-82" data-mp="eugdqbyym94a" />
        <path d="M24 6C34 6 40 14 40 24" data-id="element-83" data-mp="atmnhby1oi88" />
        <path d="M14 24C14 18 18 12 24 12C30 12 34 18 34 24" data-id="element-84" data-mp="aunxre78l0ow" />
        <path d="M18 24C18 20 20 16 24 16C28 16 30 20 30 24" strokeDasharray="2 3" data-id="element-85" data-mp="5v333fz3nehz" />
        <path d="M22 24C22 22 23 20 24 20C25 20 26 22 26 24" data-id="element-86" data-mp="ux4ffuewrqe" />
        <line x1="24" y1="24" x2="24" y2="42" data-id="element-87" data-mp="xjkk3vdcfk8" />
      </svg>
}, {
  letter: 'S',
  title: 'STABILITATE',
  subtitle: 'Treci din cap în acțiune.',
  description: 'Știi ce ar trebui să faci, dar nu faci constant? Aici treci din cap în acțiune: plan, rutine, obiective măsurabile și pași mici, reali. Nu perfecțiune. Consistență.',
  icon: <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-12 h-12 text-rise-gold" data-id="element-88" data-mp="3kpaev4urwggb">
        {/* Anchor / foundation symbol */}
        <circle cx="24" cy="12" r="5" data-id="element-89" data-mp="3auifpwljlljf" />
        <line x1="24" y1="17" x2="24" y2="40" data-id="element-90" data-mp="3frimk9q7usbl" />
        <path d="M14 40C14 34 18 30 24 30C30 30 34 34 34 40" data-id="element-91" data-mp="3fsbkcl7767hl" />
        <line x1="16" y1="24" x2="32" y2="24" data-id="element-92" data-mp="7bgq1u4gtvf4" />
        <circle cx="24" cy="12" r="2" fill="currentColor" data-id="element-93" data-mp="7crtttxwv368" />
      </svg>
}, {
  letter: 'E',
  title: 'EVOLUȚIE',
  subtitle: 'Crești pe termen lung, fără să revii.',
  description: 'Te temi că vei rămâne așa și la 30? Aici construiești mindset matur: restructurezi convingerile limitative, înveți să gestionezi frica și continui să crești pe termen lung, fără să revii la vechile tipare.',
  icon: <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-12 h-12 text-rise-gold" data-id="element-94" data-mp="2n34q3yes0425">
        {/* Rising arrow / growth symbol */}
        <path d="M6 42L18 28L26 34L42 10" data-id="element-95" data-mp="2akr392cbblgy" />
        <path d="M32 10L42 10L42 20" data-id="element-96" data-mp="2ajz8ftqjhrrq" />
        <circle cx="18" cy="28" r="2" fill="currentColor" data-id="element-97" data-mp="2phrmehgfu83t" />
        <circle cx="26" cy="34" r="2" fill="currentColor" data-id="element-98" data-mp="2ph9jx336mxng" />
      </svg>
}];
export function Awareness() {
  return <section className="bg-rise-anthracite text-rise-white py-12 md:py-20 px-6" data-id="element-99" data-mp="2kgu7cdqq5u6j">
      <div className="max-w-rise-content mx-auto" data-id="element-100" data-mp="1wtdpy64zzjud">
        <div className="text-center mb-16" data-id="element-101" data-mp="1ruj5z0vanp8o">
          <h2 className="font-playfair text-[32px] md:text-[38px] mb-2" data-id="element-102" data-mp="1rvuch8g4jb3h">
            De ce R.I.S.E.?
          </h2>
          <p className="font-dm-sans text-rise-white max-w-2xl mx-auto text-[22px]" data-id="element-103" data-mp="26l052dkgi32e">
            Patru piloni esențiali pentru a trece de la confuzie la o viață
            asumată și plină de sens.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-104" data-mp="193ro1ax8qqio">
          {blocks.map((block, index) => <div key={index} className="bg-rise-black p-8 md:p-[40px] rounded-xl border border-white/5 flex flex-col h-full relative overflow-hidden" data-id="element-105" data-mp="ccxsf1zbb645" data-mpi={index}>
              {/* Gold top accent line */}
              <div className="absolute top-0 left-0 w-full h-[2px] bg-rise-gold/40" data-id="element-106" data-mp="lbi25dmwa5g8"></div>

              {/* Icon */}
              <div className="mb-6" data-id="element-107" data-mp="q5dykbnifk9a">{block.icon}</div>

              {/* Title */}
              <h3 className="font-playfair text-[20px] md:text-[22px] font-semibold tracking-wide text-rise-gold mb-2" data-id="element-108" data-mp="v2csou76br7h">
                {block.title}
              </h3>

              {/* Subtitle */}
              <p className="font-playfair italic text-rise-white/50 text-[15px] mb-5" data-id="element-109" data-mp="1443xzxxsxw0t">
                {block.subtitle}
              </p>

              {/* Description */}
              <p className="font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-110" data-mp="35vz2ntln509j">
                {block.description}
              </p>

              {/* Decorative letter watermark */}
              <span className="absolute bottom-4 right-6 font-playfair text-[120px] leading-none text-white/[0.03] pointer-events-none select-none" data-id="element-111" data-mp="33barxvcqnd6t">
                {block.letter}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}